import CustomSelect from "../CustomSelect";
import "./styles.css";

/**
 * @name CustomInputSelect
 * @function
 * @param { STRING|NUMBER|Object|Array } value - what value to set in the input as a default
 * @param { Function } onChange - (STRING|NUMBER -> VOID) Call back function for when an input value is entered.
 * @param { Function } onCustomInputItemSelect -(STRING|NUMBER -> VOID) Call back function for when a custom item is selected.
 * @param { BOOLEAN } active - Boolean value indicating that the dropdown is active. Mostly used for captures.
 * @param { STRING } dataPoint - A data point used for the component.
 * @extends React.Component
 * @exported true
 * @description A custom component for a text input that opens a dropdown when typed into.
 * @example See comp id "ParticipantDetailsPage" for an example.
 * 
 * const routingSelectItems = data.institutions.reduce((acc, item) => {
    acc.push(
      <CustomSelectItem key={ item.id } value={ `${ item.id }` } dataPoint={ `Participant_Details_Routing_${ item.id }` }>{ `${ item.routingNumber }: ${ item.name }` }</CustomSelectItem>
    )
    return acc;
  }, []);

 * <CustomInputSelect value={ participant.routing } active={ ui.accountTypeSelectIsActive } dataPoint={ `Participant_Details_Account_Type_Select` }
    onChange={ onChange("routing") } onCustomInputItemSelect={ onRoutingInputSelect } >
    { routingSelectItems }
    </CustomInputSelect>
 */

export default function CustomInputSelect(props) {
    const value = props.value ?? "";
    const onChange = props.onChange ?? (() => {});
    const onCustomInputItemSelect = props.onCustomInputItemSelect ?? (() => {});
    const active = props.active ?? false;
    const dataPoint = props.dataPoint ? { dataPoint: props.dataPoint } : {};
    
    return (
        <CustomSelect useCustomInput={ true } { ...dataPoint } value={ value } onCustomInputItemSelect={ onCustomInputItemSelect }
         onChange={ onChange } active={ active }>
            { props.children }
        </CustomSelect>  
    );
}

export { CustomInputSelect };
